var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgKnowledgeBase = function SvgKnowledgeBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M5.215 22.957C3.442 22.957 2 21.553 2 19.827c0-1.727 1.442-3.131 3.215-3.131h16.611v6.26H5.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M21.304 0H4.61A2.609 2.609 0 002 2.609v17.739A3.652 3.652 0 005.652 24h15.652a.522.522 0 100-1.043H5.77c-1.362 0-2.58-.993-2.713-2.348a2.612 2.612 0 012.596-2.87h15.652a.522.522 0 00.522-.522V.522A.522.522 0 0021.304 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M21.826 20.87H4.625a.53.53 0 01-.538-.522.53.53 0 01.538-.522h17.201v1.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ebfd5",
    d: "M18.696 0h-4.174v7.304l2.087-1.123 2.087 1.123z"
  }))));
};

export default SvgKnowledgeBase;